import styled, { css } from "styled-components";

export const Container = styled.main`
  padding: 2rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    padding: 1.5rem;
  }
`;

export const Content = styled.section`
  margin-top: 1.5rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    margin-top: 1rem;
  }
`;

interface AutoPrintStatusContainerProps {
  status?:
    | "IN_PROGRESS"
    | "STANDING_BY"
    | "COMPLETED"
    | "ERROR"
    | "CANCELED"
    | "in_progress"
    | "error"
    | "completed"
    | "canceled";
}

export const RolesContainer = styled.div<AutoPrintStatusContainerProps>`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: ${(props) => props.theme.newColors["gray-550"]};
  border-radius: 200px;

  p {
    font-size: ${(props) => props.theme.fontSize.XXXS};
    color: ${(props) => props.theme.colors["gray-850"]};
  }

  ${(props) =>
    (props.status === "canceled" || props.status === "CANCELED") &&
    css`
      background-color: ${(props) => props.theme.newColors["gray-400"]};
    `};

  ${(props) =>
    (props.status === "completed" || props.status === "COMPLETED") &&
    css`
      background-color: ${(props) => props.theme.newColors["green-400"]};
    `};

  ${(props) =>
    (props.status === "error" || props.status === "ERROR") &&
    css`
      background-color: ${(props) => props.theme.newColors["red-400"]};
    `};

  ${(props) =>
    (props.status === "in_progress" || props.status === "IN_PROGRESS") &&
    css`
      background-color: ${(props) => props.theme.newColors["yellow-400"]};
    `};

  ${(props) =>
    props.status === "STANDING_BY" &&
    css`
      background-color: ${(props) => props.theme.newColors["blue-400"]};
    `};
`;
